<template>
    <group-details :groupId="props.groupId">
        <group-calendly-list :groupId="props.groupId"></group-calendly-list>
    </group-details>
</template>

<script setup lang="ts">
import GroupDetails from '../GroupDetails.vue';
import GroupCalendlyList from './GroupCalendlyList.vue';

const props = defineProps({
    groupId: {
        type: String,
        required: true,
    },
});
</script>
